import { HiCheck, HiDatabase, HiPencil, HiShieldCheck } from "react-icons/hi";
import WithIcon from "../../WithIcon";
import { Badge } from "./Badges";
import {
  EXAMPLE_ACTOR_ID,
  EXAMPLE_ROLE,
  EXAMPLE_RESOURCE_ID,
} from "../constants";
import { StarterPolicy } from "../types";

export const RulesAndDataDiagram: React.FC<{
  policy?: StarterPolicy;
}> = ({ policy }) => {
  return (
    <div className="flex flex-row items-stretch space-x-3 mt-8 mb-8">
      <div className="p-4 border border-black rounded w-full">
        <div className="flex flex-col items-center space-y-3">
          <div className="text-xl">
            <WithIcon icon={<HiPencil />}>Rules</WithIcon>
          </div>
          {policy && (
            <div>
              A <Badge>{policy.actor}</Badge> with the <Badge>viewer</Badge>{" "}
              role can <Badge>view</Badge> an{" "}
              <Badge>{policy.businessObject}</Badge> that allows{" "}
              <Badge>viewers</Badge> to view it.
            </div>
          )}
        </div>
      </div>

      <div className="shrink flex items-center text-2xl">
        <div>+</div>
      </div>

      <div className="p-4 border border-black rounded w-full">
        <div className="flex flex-col items-center space-y-3">
          <div className="text-xl">
            <WithIcon icon={<HiDatabase />}>Facts</WithIcon>
          </div>

          {policy && (
            <div>
              <Badge>
                {policy.actor}:{EXAMPLE_ACTOR_ID}
              </Badge>{" "}
              is a <Badge>{EXAMPLE_ROLE}</Badge> on{" "}
              <Badge>
                {policy.businessObject}:{EXAMPLE_RESOURCE_ID}
              </Badge>{" "}
            </div>
          )}
        </div>
      </div>

      <div className="shrink flex items-center text-2xl">
        <div>=</div>
      </div>

      <div className="p-4 border border-black rounded w-full">
        <div className="flex flex-col items-center space-y-3">
          <div className="text-xl">
            <WithIcon icon={<HiShieldCheck />}>Decision</WithIcon>
          </div>
          {policy && (
            <div className="flex flex-row items-start">
              <div className="pt-1 pr-2 text-green-500">
                <HiCheck />
              </div>
              <div>
                <Badge>
                  {policy.actor}:{EXAMPLE_ACTOR_ID}
                </Badge>{" "}
                can <Badge>view</Badge>{" "}
                <Badge>
                  {policy.businessObject}:{EXAMPLE_RESOURCE_ID}
                </Badge>
                .
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};
